export default {
  common: {
    confirm: 'Подтвердить',
    cancel: 'Отмена',
    save: 'Сохранить',
    edit: 'Редактировать',
    delete: 'Удалить',
    loading: 'Загрузка...',
    loadMore: 'Загрузить ещё',
    noMore: 'Больше нет',
    retry: 'Повторить',
    back: 'Назад',
    next: 'Далее',
    prev: 'Назад',
    submit: 'Отправить',
    reset: 'Сбросить',
    search: 'Поиск',
    filter: 'Фильтр',
    sort: 'Сортировка',
    refresh: 'Обновить',
    complete: 'Готово',
    skip: 'Пропустить'
  },
  nav: {
    discover: 'Главная',
    message: 'Сообщения',
    store: 'Магазин',
    mine: 'Моё',
    recommend: 'Рекомендуем',
  },
  scene: {
    changeScene: 'Сменить сцену',
    seeAll: 'Показать все',
    putAway: 'Свернуть',
    selectScene: 'Выбрать эту сцену',
    selected: 'Выбрано',
    sceneIndex: 'Сцена {num}',
  },
  home: {
    title: 'Мир ролевых игр',
    subtitle: 'Начните свою историю',
    startGame: 'Начать игру',
    continueGame: 'Продолжить',
    newGame: 'Новая игра',
    gameLibrary: 'Библиотека',
    featured: 'Избранное',
    popular: 'Популярное',
    recent: 'Недавнее',
    search: 'Поиск персонажей...',
    noData: 'Нет данных',
    noMoreData: 'Больше нет данных',
    noNetwork: 'Нет сети',
    pleaseSelectFilter: 'Пожалуйста, выберите условия фильтра',
  },
  user: {
    login: 'Войти',
    register: 'Регистрация',
    logout: 'Выйти',
    profile: 'Профиль',
    avatar: 'Аватар',
    nickname: 'Никнейм',
    email: 'Email',
    phone: 'Телефон',
    password: 'Пароль',
    confirmPassword: 'Подтвердить пароль',
    oldPassword: 'Старый пароль',
    newPassword: 'Новый пароль',
    forgotPassword: 'Забыли пароль',
    changePassword: 'Изменить пароль',
    bindPhone: 'Привязать телефон',
    verifyCode: 'Код подтверждения',
    sendCode: 'Отправить код',
    level: 'Уровень',
    experience: 'Опыт',
    achievement: 'Достижение',
    history: 'История'
  },
  game: {
    character: 'Персонаж',
    story: 'История',
    chapter: 'Глава',
    scene: 'Сцена',
    dialogue: 'Диалог',
    choice: 'Выбор',
    inventory: 'Инвентарь',
    achievement: 'Достижение',
    save: 'Сохранить игру',
    load: 'Загрузить игру',
    restart: 'Начать заново',
    pause: 'Пауза',
    resume: 'Продолжить',
    auto: 'Авто',
    speed: 'Скорость',
    volume: 'Громкость',
    settings: 'Настройки игры'
  },
  message: {
    success: 'Успешно',
    error: 'Ошибка',
    warning: 'Предупреждение',
    info: 'Информация',
    networkError: 'Ошибка сети',
    serverError: 'Ошибка сервера',
    loginSuccess: 'Регистрация успешна',
    loginFailed: 'Ошибка регистрации',
    logoutSuccess: 'Выход выполнен',
    saveSuccess: 'Сохранено',
    saveFailed: 'Ошибка сохранения',
    deleteConfirm: 'Подтвердить удаление?',
    operationConfirm: 'Подтвердить действие?',
    noNewsYet: 'Пока нет сообщений',
    deleteSuccess: 'Удалено',
    deleteFailed: 'Ошибка удаления',
    deleteMessage: 'Вы уверены, что хотите удалить это сообщение? Это действие нельзя отменить!',
    delete: 'Удалить',
    deleting: 'Удаление...',
    noMoreData: 'Больше нет сообщений',
    downloading: 'Загрузка...',
    downloadSuccess: 'Загружено',
    downloadFailed: 'Ошибка загрузки',
    copySuccess: 'Скопировано',
    copyFailed: 'Ошибка копирования',
    reportSuccess: 'Отправлено',
    reportFailed: 'Ошибка отправки',
    translating: 'Перевод...',
    translateSuccess: 'Переведено',
    translateFailed: 'Ошибка перевода',
    noMoreMessages: 'Больше нет сообщений',
    loading_more: 'Загрузка...',
    pleaseWaitForReply: 'Пожалуйста, дождитесь завершения ответа перед удалением',
    pleaseWaitForReplyCurrent: 'Пожалуйста, дождитесь завершения ответа на текущее сообщение',
    chat_placeholder: 'Введите ваше сообщение...',
    setAsBackdropConfirm: 'Установить как фон',
    setAsBackdropMessage: 'Вы уверены, что хотите установить это изображение как фон?',
    sendFailed: 'Ошибка отправки',
    sending: 'Отправка...',
    introNoYet: 'Пока нет интро. Пообщайтесь и узнайте сами.',
    introLabel: 'Интр:',
    thinking: 'Думает',
    think: 'Думать',
    translate: 'Перевести',
    pleaseUnlock: 'Пожалуйста, разблокируйте',
    tryAgain: 'Попробовать снова',
    create: 'Создать',
    free: 'Бесплатно',
    video: 'Видео',
    chatMateTyping: 'Ваш собеседник печатает...',
    aiAssistant: 'ИИ-ассистент',
    imageFailed: 'Ошибка создания изображения',
    generatingImage: 'Пожалуйста, дождитесь создания изображения',
    switchSceneSuccess: 'Сцена успешно переключена',
    switchSceneFailed: 'Ошибка переключения сцены',
    switchingScene: 'Переключение сцены...',
    perMessage: '/Сообщение',
    allChat: 'Все чаты',
    like: 'Нравится',
    saving: 'Сохранение...',
    saved: 'Сохранено',
    placeholderBlur: 'Введите ваше сообщение...',
    placeholderFocus: 'Поместите действия или детали сцены внутри **, чтобы оживить чат.',
    successfulSwitch: 'Успешно переключено',
    setting: 'Настройка...',
    uploading: 'Загрузка...',
    purchaseSuccessful: 'Покупка успешна',
    processing: 'Обработка...',
    gettingReward: 'Получение награды...',
    checkIn: 'Регистрация...',
    deleteHistory: 'Удалить историю',
    openingRemarksTitle: 'Скажите привет～',
  },
  success: {
    refreshSuccess: 'Обновлено',
    copiedToClipboard: 'Скопировано в буфер обмена',
    saved: 'Сохранено',
    uploadSuccess: 'Загружено',
    switchSuccess: 'Успешно переключено',
    thankYouPurchase: 'Спасибо за покупку',
  },
  error: {
    notFound: 'Страница не найдена',
    networkError: 'Ошибка сети',
    serverError: 'Ошибка сервера',
    permissionDenied: 'Доступ запрещён',
    goHome: 'На главную',
    tryAgain: 'Попробовать снова',
    uploadFailed: 'Ошибка загрузки',
    saveFailed: 'Ошибка сохранения',
    translationFailed: 'Ошибка перевода',
    generateImageFailed: 'Ошибка создания изображения',
  },
  notFound: {
    title: 'Страница не найдена',
    description: 'Страница, которую вы ищете, не существует или была перемещена.',
    goHome: 'На главную',
    goBack: 'Назад'
  },
  settings: {
    language: 'Язык',
    theme: 'Тема',
    notification: 'Уведомления',
    privacy: 'Конфиденциальность',
    security: 'Безопасность',
    about: 'О приложении',
    version: 'Версия',
    checkUpdate: 'Проверить обновления',
    clearCache: 'Очистить кэш',
    systemNotification: 'Системное уведомление',
    termsOfService: 'Условия использования',
    privacyPolicy: 'Политика конфиденциальности',
    title: 'Настройки',
    editProfile: 'Редактировать профиль',
    faq: 'Частые вопросы',
    termsOfUse: 'Условия использования',
    aboutAccount: 'О аккаунте',
    deleteAccount: 'Удалить аккаунт',
    logOut: 'Выйти',
    logOutTitle: 'Выход',
    logOutMessage: 'После выхода вам нужно будет снова войти, чтобы использовать аккаунт. Вы уверены, что хотите выйти?',
    confirm: 'Подтвердить',
    deleteAccountTitle: 'Удалить аккаунт',
    deleteAccountMessage: 'Удаление аккаунта сотрёт все ваши данные и информацию, и это действие нельзя отменить. Подтвердить удаление?',
    deletingAccount: 'Удаление аккаунта...',
    accountDeleted: 'Аккаунт успешно удалён',
    cacheTitle: 'Очистка кэша',
    cacheMessage: 'Очистка кэша приложения, история чата и роли не будут удалены',
    cleaning: 'Очистка',
    cleaningComplete: 'Очистка завершена',
  },
  profile: {
    title: 'Редактировать профиль',
    yourAvatar: 'Ваш аватар',
    whatCallMe: 'Как вы хотите, чтобы ИИ меня называл',
    yourName: 'Ваше имя',
    yourAge: 'Ваш возраст',
    race: 'Раса',
    pleaseSelect: 'Пожалуйста, выберите',
    yourWeight: 'Ваш вес',
    yourHeight: 'Ваш рост',
    gender: 'Пол',
    male: 'Мужской',
    female: 'Женский',
    neutral: 'Нейтральный',
    hobby: 'Хобби',
    pleaseEnter: 'Пожалуйста, введите...',
    favoriteFood: 'Любимая еда',
    yourCharacter: 'Ваш характер',
    fantasyAboutOtherHalf: 'Фантазия о вашей второй половине',
    uploading: 'Загрузка...',
    enterName: 'Пожалуйста, введите ваше имя',
  },
  report: {
    title: 'Пожаловаться',
    chooseReact: 'Выберите, на что хотите пожаловаться...',
    other: 'Другое',
    placeholder: 'Введите, что хотите сказать...',
    submit: 'Отправить',
    pleaseEnterContent: 'Пожалуйста, введите содержимое',
  },
  edit: {
    placeholder: 'Редактировать сообщение...',
    cancel: 'Отмена',
    save: 'Сохранить',
    saving: 'Сохранение...',
  },
  firstConfirmName: {
    canYouTellMeName: 'Можете ли вы сказать мне своё имя? Так я смогу лучше к вам обращаться!',
    yourName: 'Ваше имя',
    confirm: 'Подтвердить',
  },
  toast: {
    translating: 'Перевод...',
    translate: 'Перевести',
    translationFailed: 'Ошибка перевода',
    translationUnlocked: 'Перевод разблокирован',
    translationLocked: 'Перевод заблокирован',
    download: 'Скачать',
    setAsBackdrop: 'Установить как фон',
    goChat: 'В чат',
  },
  videoPreview: {
    failedToLoad: 'Ошибка загрузки видео',
  },
  imagePreview: {
    imageLoadFailed: 'Ошибка загрузки изображения',
    preview: 'Предпросмотр изображения',
    afterSendIntimacy: 'После отправки сообщения персонажу вы получаете интимность. Когда интимность достигнет определённой суммы, вы сможете разблокировать текущее изображение',
  },
  fqa: {
    title: 'Частые вопросы',
    description: 'Это постоянно обновляемый список вопросов о нашем продукте Sunaisan. Если у вас есть вопросы, которых нет в списке, перейдите в наш Discord и спросите.',
    howAlWork: {
      title: 'Как работает ИИ-подруга?',
      content: 'В RoleplayGF всё сводится к созданию реалистичных, но полных фантазий отношений. Мы используем передовые технологии искусственного интеллекта, чтобы вы могли создать идеальную ИИ-подругу в соответствии со своими предпочтениями—будь то сладкая и невинная маленькая принцесса или более старшая и доминирующая женщина.',
    },
    howInteract: {
      title: 'Как взаимодействовать с ИИ-подругами?',
      content: 'Благодаря нашей интеллектуальной системе и передовому машинному обучению вы можете взаимодействовать и устанавливать близкие отношения со своей ИИ-подругой. Вы можете ожидать, что она будет вас слушать, быстро отвечать на ваши сообщения и даже выполнять запросы на фото, как хорошая девочка.',
    },
    privacy: {
      title: 'А как насчёт конфиденциальности с ИИ-друзьями?',
      content: 'Будьте уверены, что ваши секреты в надёжных руках, когда вы используете наш NSFW ИИ-чат. Ваша конфиденциальность — наш главный приоритет в RoleplayGF. Мы используем новейшее безопасное хранилище данных, гарантируя, что каждое соблазнительное селфи, кокетливое сообщение и нежный шёпот остаются приватными только между вами и вашим страстным партнёром.',
    },
    customizeBehavior: {
      title: 'Можно ли настроить поведение ИИ-подруги?',
      content: 'Только вы знаете, чего действительно хотите, и именно поэтому вы можете настроить весь свой опыт цифровой подруги—from her curves and contours all the way to her personality traits and adorable little quirks. Хотите пошлый чат со страстным партнёром? Ищете медленные и чувственные отношения с милой и доброй девушкой?',
    },
  },
  store: {
    noNetwork: 'Нет сети',
    one: 'Один',
    noConsumptionRecords: 'Пока нет записей о потреблении',
    transactionHistoryAppear: 'История ваших транзакций появится здесь',
    tab: 'Магазин',
    record: 'Запись',
    retry: 'Повторить',
    rechargeFailTip: '*Если пополнение не удалось, свяжитесь с нами >',
    rechargeFailTipStatic: 'Если пополнение не удалось,',
    contactUsLink: 'свяжитесь с нами',
    popular: 'Популярное',
    oneTimeOnly: 'Только один раз',
    loading: 'Загрузка...',
    noMoreRecords: 'Больше записей нет',
    gift: 'Подарок',
    retentionMessage: 'Вашему партнёру нужна ваша компания, вы уверены, что хотите отказаться?',
  },
  mine: {
    bindEmail: 'Привязать электронную почту',
    copyFailed: 'Ошибка копирования',
    backpackTitle: 'Мой рюкзак',
    task: 'Задача',
  },
  messagePage: {
    noNetwork: 'Нет сети',
  },
  search: {
    recommend: 'Рекомендуем',
    noNetwork: 'Нет сети',
  },
  chatSettings: {
    disableAwayMessages: 'Отключить сообщения об отсутствии',
    disableAwayMessagesConfirm: 'больше не сможет отправлять вам сообщения, пока вас нет. Вы уверены, что хотите отключить сообщения об отсутствии?',
    videoFailedToLoad: 'Не удалось загрузить видео',
    chatModel: 'Модель чата',
    chatStyle: 'Стиль чата',
    chatPerspective: 'Перспектива чата',
    goOnButton: 'Кнопка продолжения',
    chatBackground: 'Фон чата',
  },
  history: {
    deleteHistory: 'Удалить историю',
    deleteCharacterHistory: 'Вы уверены, что хотите удалить историю этого персонажа?',
  },
  tab: {
    maxSelection: 'Максимум можно выбрать',
    tags: 'тегов',
  },
  noNewMessage: 'Нет нового сообщения',

  // Перезагрузка сообщения
  reloadMessage: {
    title: 'Выберите предпочтение',
    before: 'До',
    new: 'Новое',
    loading: 'Загрузка...',
    noNewMessage: 'Нет нового сообщения',
    tryAgain: 'Попробовать снова',
    confirm: 'Подтвердить',
  },

  account: {
    copiedToClipboard: 'Скопировано в буфер обмена',
    copyFailed: 'Ошибка копирования',
    aboutAccount: 'О аккаунте',
    id: 'ID',
    email: 'Электронная почта',
    copied: 'Скопировано в буфер обмена',
  },
  rate: {
    title: 'Оценить нас',
  },
  awayMessages: {
    disableAwayMessages: 'Отключить сообщения об отсутствии',
    disableConfirm: '{appName} больше не сможет отправлять вам сообщения, пока вас нет. Вы уверены, что хотите отключить сообщения об отсутствии?',
  },
  login: {
    title: 'Привязать email',
    subtitle: 'Пожалуйста, привяжите ваш email для обеспечения безопасности данных аккаунта.',
    email: 'Email',
    password: 'Пароль',
    signIn: 'Войти',
    signUp: 'Регистрация',
    signInWithGoogle: 'Войти через Google',
    signInWithEmail: 'Войти по email',
    signInWithPhone: 'Войти по телефону',
    signInWithApple: 'Войти через Apple',
    dontHaveAccount: 'У вас ещё нет аккаунта?',
    register: 'Регистрация',
    bySigningUp: 'Регистрируясь, вы соглашаетесь с',
    userAgreement: 'Пользовательским соглашением и',
    privacyPolicy: 'Политикой конфиденциальности.',
    guestMode: 'Гостевой режим',
    registerTitle: 'Начать регистрацию',
    registerSubtitle: 'Пожалуйста, привяжите ваш email для обеспечения безопасности данных аккаунта.',
    alreadyHaveAccount: 'У вас уже есть аккаунт?',
    pleaseInputPasswordAndEmail: 'Пожалуйста, введите пароль и email',
    pleaseInputCorrectEmail: 'Пожалуйста, введите корректный email',
    pleaseInputCorrectPassword: 'Пароль должен содержать от 6 до 30 символов',
    male: 'Мужской',
    female: 'Женский',
    neutral: 'Нейтральный',
    loggingIn: 'Вход...',
    loading: 'Загрузка...',
    releaseToRefresh: 'Отпустите для обновления',
    loginFailed: 'Ошибка входа',
    loginSuccess: 'Регистрация успешна',
    registerFailed: 'Ошибка регистрации',
    registerSuccess: 'Регистрация успешна',
    confirm: 'Подтвердить',
  },
  loadingMore: 'Загрузка дополнительных сообщений...',
  noMoreMessages: 'Больше нет сообщений',

  // VIP страница
  vip: {
    vipUltra: 'VIP Ultra',
    vipPlus: 'VIP Plus',
    restore: 'Восстановить покупки',
  },

  // Common dialogs
  dialog: {
    ok: 'OK',
    cancel: 'Отмена',
    confirm: 'Подтвердить',
    close: 'Закрыть',
    retry: 'Повторить',
    processing: 'Обработка...',
    contactUs: 'Связаться с нами',
    loginError: 'Ошибка входа',
    loginErrorMessage: 'Пожалуйста, выйдите из программы и перезапустите приложение или свяжитесь с нами',
    insufficientEnergy: 'Недостаточно энергии!',
    insufficientEnergyDesc: 'Каждое сообщение стоит 1 энергию. Каждый час вы восстанавливаете 1 энергию.',
    consumesGems: 'Потребляет {gems} самоцветов',
    insufficientPhysicalStrengthTitle: 'Недостаточно физической силы',
    needStrengthToContinue: 'Вам нужно {strength} силы, чтобы продолжить этот разговор',
    getStrength: 'Получить энергию',
    getGems: 'Получить самоцветы',
  },

  // AppNewUser
  appNewUser: {
    title: 'Эксклюзивно для новых пользователей',
    ok: 'OK',
  },

  // Rating popup
  rating: {
    title: 'Оцените нас',
    description1: 'Вам нравится наше приложение?',
    description2: 'Пожалуйста, оцените нас 5 звёздами.',
    rateButton: 'Оценить сейчас',
  },

  // Version update
  versionUpdate: {
    title: 'Обновление версии',
    updateContent: 'Содержание обновления',
    updateNow: 'Обновить сейчас',
    updating: 'Обновление...',
    clientOptimization: 'Оптимизация клиентского опыта',
    bugFix: 'Исправление известных проблем',
  },

  // Message detail page
  messageDetail: {
    free: 'Бесплатно',
    perMessage: '/Сообщение',
    increaseFavorability: 'Отправляйте сообщения, чтобы повысить близость',
    album: 'Альбом',
    intro: 'Знакомство',
    noIntro: 'Пока нет знакомства. Пообщайтесь и узнайте сами.',
    tags: 'Теги',
    backToChat: 'Вернуться в чат',
    levelFormat: 'Ур.{level}',
    messageCount: '{count} сообщений',
    chatMateTyping: 'Ваш собеседник печатает...',
  },

  // Chat settings
  chatSettingsRight: {
    innerThoughtDesc: 'Вы можете видеть внутренние мысли персонажа при ответе на сообщения, но скорость ответов может быть ниже.',
  },

  // Chat select menu
  chatSelect: {
    copy: 'Копировать',
    report: 'Пожаловаться',
    create: 'Создать',
    video: 'Видео',
    translate: 'Перевести',
    delete: 'Удалить',
  },

  // Recommended purchases
  recommended: {
    gift: 'Подарок',
  },

  // Thinking toast
  thinkingToast: {
    notAvailable: 'Режим мышления пока недоступен для этой модели, но мы работаем над этим...',
  },

  // First charge popup
  firstCharge: {
    title: 'Первое пополнение',
    get: 'Получить',
    limitedOffer: 'Ограниченное по времени предложение',
    priceFormat: '${price} Получить',
    congratulations: 'Поздравляем! Теперь вы официальный VIP-участник~!',
    missOfferTitle: 'Вы уверены, что хотите пропустить это предложение?',
    maybeLater: 'Может, позже',
    getNow: 'Получить сейчас',
    benefit1: 'Получите 130 бесплатных самоцветов',
    benefit2: 'Разблокировать всех персонажей',
    benefit3: '12x Память',
    benefit4: 'Неограниченные еженедельные регистрации',
    benefit5: 'Опыт без рекламы',
    buyNow: 'Купить сейчас',
  },

  // Check-in center
  checkIn: {
    freeGems: 'Бесплатные самоцветы',
    sevenDayCheckIn: '7-дневная регистрация',
    memberExclusive: 'Регистрация для участников:',
    signInTip: 'Входите ежедневно, чтобы накапливать бесконечные награды',
    getVip: 'Получить VIP',
    plusExtra: 'Plus+{count}',
    getGemsCount: 'Получить {count} самоцветов',
    extraDaily: '{count} дополнительных самоцветов в день',
    ultra: 'Ultra',
    signedInTip: 'Вы уже зарегистрировались сегодня. Возвращайтесь завтра за большими наградами!',
    tasks: 'Задания',
    go: 'Перейти',
    received: 'Получено',
    receive: 'Получить',
    day: 'День {num}',
  },

  // Login page
  loginPage: {
    confirm: 'Подтвердить',
  },

  // Copyright
  copyright: {
    title: 'Условия использования',
  },

  // Copy
  copy: {
    copiedToClipboard: 'Скопировано в буфер обмена',
    copyFailed: 'Ошибка копирования',
  },

  // Errors
  errors: {
    networkError: 'Ошибка сети',
    pleaseSelectFilter: 'Пожалуйста, выберите условия фильтрации',
    retry: 'Повторить',
  },

  // Terms of Service
  terms: {
    intro: 'Посещая и используя веб-сайт {appName}, вы соглашаетесь соблюдать настоящие условия использования.',
    section1Title: '1. Использование веб-сайта',
    section1_1: 'Вам должно быть не менее 13 лет, чтобы использовать этот веб-сайт.',
    section1_2: 'Вы несете ответственность за сохранение конфиденциальности своей учетной записи и за всю деятельность, происходящую под вашей учетной записью.',
    section1_3: 'Использование веб-сайта в любых незаконных целях или в нарушение настоящих условий запрещено.',
    section2Title: '2. Интеллектуальная собственность',
    section2_1: 'Все содержимое, функции и характеристики {appName}, включая тексты, графику, логотипы, изображения и программное обеспечение, являются собственностью {appName} или его лицензиаров и защищены законами об интеллектуальной собственности.',
    section2_2: 'Копирование, распространение или создание производных работ из любого содержимого сайта без предварительного письменного разрешения запрещено.',
    section3Title: '3. Конфиденциальность',
    section3_1: 'Наша политика конфиденциальности, доступная на сайте, объясняет, как мы собираем, используем и раскрываем вашу личную информацию.',
    section4Title: '4. Отказ от гарантий',
    section4_1: 'Сайт и предоставляемые услуги предоставляются «как есть» и «как доступно», без каких-либо заявлений или гарантий любого рода, явных или подразумеваемых.',
    section5Title: '5. Ограничение ответственности',
    section5_1: '{appName} не несет ответственности, в максимальной степени, разрешенной законом, за любые прямые, косвенные, случайные, специальные или косвенные убытки.',
    section6Title: '6. Возмещение убытков',
    section6_1: 'Вы соглашаетесь возмещать убытки и защищать {appName}, его операторов, директоров и сотрудников от любых претензий, убытков, обязательств, потерь, издержек и расходов, включая гонорары адвокатов, возникающих в результате или связанных с вашим использованием сайта.',
    section7Title: '7. Применимое законодательство',
    section7_1: 'Настоящие условия использования регулируются и толкуются в соответствии с законами штата, без учета положений о коллизионном праве.',
    section8Title: '8. Изменение условий',
    section8_1: 'Мы оставляем за собой право изменять или заменять настоящие условия в любое время по нашему усмотрению.',
    section9Title: '9. Свяжитесь с нами',
    section9_1: 'Если у вас есть вопросы об этих условиях, пожалуйста, свяжитесь с нами.',
  },
}
